import React, {useState} from "react";
import Header from "../../main/Header/Header";
import BrandSidebar from "../../main/BrandSidebar/BrandSidebar";

const BrandLayout = ({ children }) => {
    
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };
    return (
        <div className='w-full h-full'>
            <Header onMenuToggle={toggleMobileMenu}/>
            <div className='flex justify-between h-[90%]'>
                <BrandSidebar  isOpen={isMobileMenuOpen} 
                onClose={() => setIsMobileMenuOpen(false)} />
                {children}
            </div>
        </div>
    )
};

export default BrandLayout;
